module.exports = require('./lib/supermodels');
